import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { useOrgBatchDetail, useOrgAssignmentDetail } from '@/lib/hooks/useOrg';
import { AssignmentDetailView } from '@/features/OrgLayout/batchDetail/AssignmentDetailView';

export const Route = createFileRoute('/org/batches/$batchId/assignments/$assignmentId')({
  component: AssignmentDetailPage,
});

function AssignmentDetailPage() {
  const { batchId, assignmentId } = Route.useParams();
  const { data: batch } = useOrgBatchDetail(batchId);
  const { data, isLoading, isError, refetch } = useOrgAssignmentDetail(batchId, assignmentId);
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="space-y-5">
        <Skeleton className="h-6 w-72" />
        <Skeleton className="h-32 rounded-[24px]" />
        <Skeleton className="h-64 rounded-[24px]" />
      </div>
    );
  }
  if (isError || !data) {
    return (
      <div className="flex flex-col items-center py-16 text-center">
        <p className="text-[#6b7280]">Couldn&apos;t load this assignment.</p>
        <Button className="mt-4" onClick={() => refetch()}>Retry</Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <nav className="flex flex-wrap items-center gap-1.5 text-sm text-[#6b7280]">
        <button type="button" onClick={() => navigate({ to: '/org/batches' })} className="hover:text-[#111827]">Batches</button>
        <span className="text-[#9ca3af]">›</span>
        <button type="button" onClick={() => navigate({ to: '/org/batches/$batchId', params: { batchId } })} className="hover:text-[#111827]">{batch?.batch.name ?? 'Batch'}</button>
        <span className="text-[#9ca3af]">›</span>
        <span className="font-medium text-[#111827]">{data.title}</span>
      </nav>

      <AssignmentDetailView data={data} />
    </div>
  );
}
